export var getHeaderButtons = function getHeaderButtons(urlServices) {
  return fetch("".concat(urlServices, "/services-v2/header-buttons")).then(function (response) {
    return response.json();
  }).then(function (data) {
    return data;
  });
};